import { Dialog, DialogContent, DialogProps } from '@mui/material'
import React, { PropsWithChildren } from 'react'
import { boxShadows } from '../StyleConstants'

const LassoModal = (props: PropsWithChildren<DialogProps>) => {

    return (
        <Dialog {...props}>
            <DialogContent sx={{
                padding: "16px",
                boxShadow: boxShadows.levelFive
            }}>
                {props.children}
            </DialogContent>
        </Dialog>
    )
}

export default LassoModal